import { route as routeFn } from 'ziggy-js'
import { Ziggy } from '@/ziggy'
/**
 * @import { RouteList, RouteParams, Router as RouterClass } from 'ziggy-js'
 */

/**
 * @returns {RouterClass}
 */
export const Router = () => {
  return routeFn(undefined, undefined, false, { ...Ziggy, url: '' })
}

/**
 * @template {keyof RouteList} T
 * @param {T} name
 * @param {RouteParams<T> | undefined} [params]
 * @returns
 */
export const route = (name, params) => {
  const router = routeFn(name, params, false, { ...Ziggy, url: '' })
  const url = new URL(router, window.location.origin)
  if (getPK() !== '') {
    // IROOTSPJ_DEV_HJ-3997 ログアウト状態はPKが取得できないので、付与しない
    url.searchParams.append('PK', getPK())
  }

  return url.toString()
}

/**
 * @returns {string}
 */
const getPK = () => {
  const meta = document.querySelector('meta[name="pk_value"]')

  return meta?.getAttribute('content') ?? ''
}
